/**
 * Réponses à une question retirée du schéma (« Aménagements nécessaires ? »,
 * fondue dans la question handicap) encore présentes dans les analyses déjà
 * remplies : elles restent lisibles en relecture et suivent l'analyse jusqu'au
 * questionnaire du client, sans être reposées.
 */
export const BESOIN_COMMUN_ANCIENNES_CLES = ['amenagements', 'amenagementsDetail']

export function anciennesReponsesBesoin(sectionKey, data) {
  if (sectionKey !== 'accessibilite' || data?.amenagements !== true) return []
  return [{ key: 'amenagements', label: 'Autres aménagements', value: data.amenagementsDetail || 'Oui' }]
}
